<template>
  <div class="job-lang-skill">
    <p class="job-lang-skill__label">{{ nameLabel }}</p>
    <div class="job-lang-skill__level">
      <svg-thumb-up
        v-for="i in 5"
        :key="`JobLanguageSkillItem${name}Level${i}`"
        :class="i <= level ? 'job-lang-skill__level-icon--active' : ''"
        class="job-lang-skill__level-icon svg-fill"
      />
    </div>
  </div>
</template>

<script>
import SvgThumbUp from '../../../assets/svg/thumbUp.svg?inline'

export default {
  components: {
    'svg-thumb-up': SvgThumbUp,
  },
  computed: {
    nameLabel() {
      // Fallback to language name if translation not exist
      return this.$tf('language', this.name)
    },
  },
  props: {
    level: {
      required: true,
      type: Number,
    },
    name: {
      required: true,
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.job-lang-skill__level-icon {
  @apply text-grey-light;
  width: 1em;
  height: 1em;

  &.job-lang-skill__level-icon--active {
    @apply text-yellow-medium;
  }
  &:not(:first-child) {
    margin-left: 0.75em;
  }
}
</style>
